WiseMetering.Views.DeleteUser = WiseMetering.Views.Modal.Destroy.extend({
    title: () => i18next.t('modal.title.users.destroy'),

    data: function() {
        return { organization_id: WiseMetering.currentOrganization.id };
    }
});
